import { ReactNode, CSSProperties } from "react";
import { theme } from "antd";

interface CardProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  bodyStyle?: CSSProperties;
  size?: "small" | "default";
  onClick?: () => void;
}

export function Card({
  children,
  className,
  style,
  bodyStyle,
  size = "default",
  onClick,
}: CardProps) {
  const { token } = theme.useToken();

  return (
    <div
      className={`feed-card card-container ${className || ""}`}
      style={{
        ...style,
      }}
      onClick={onClick}
    >
      <div
        className="card-content"
        style={{
          ...bodyStyle,
        }}
      >
        {children}
      </div>
    </div>
  );
}
